import axios from 'axios'
import store from '@/store'
import {
  authHeader
} from './../_helpers/_auth-header'

function getUrlApiPedidoArchivos(empresa_id, pedido_id) {
    return store.state.urlBase + `/api/v3/${empresa_id}/pedidos/archivos/${pedido_id}`;
}

function sendArchivo(empresa_id, pedido_id, formData) {
    
    let urlApiPedidoArchivos = getUrlApiPedidoArchivos(empresa_id, pedido_id);
    // console.log('Datos de store en servicio...:', store.state.urlBase, store.state.firma);

    let headers = authHeader();
    
    return axios.post(urlApiPedidoArchivos,
        formData, {
            headers
        }
    ).then((response) => {
        console.log(response);
        if (response.statusText == 'OK') {
            let result = response.data.data;
            console.log('upload pedidoarchivos OK!');
            return result;
        } else {
            console.log('Problemas con el upload')
        }
    }).catch((error) => {
        console.log('Error de upload!');
        console.log(error);
    })
}

function listArchivos(empresa_id, pedido_id) {

    let urlApiPedidoArchivos = getUrlApiPedidoArchivos(empresa_id, pedido_id);
    let headers = authHeader();

    return axios.get(urlApiPedidoArchivos, {
        headers
      })
      .then((response) => {
        let result = response.data;
        if (result.data) {
        //   console.log(result.data);
          let files = result.data;
          return files;
        } else {
          console.log('Error, sin data');
          return [];
        }
      })
      .catch((error) => {
        console.log('Error get list files: ',error);
      });

}

function getArchivo(pedido_id, archivo_id) {
    
    let imageUrl = store.state.urlBase +`/api/v3/pedidos/archivo_${pedido_id}-${archivo_id}`;
    let headers = authHeader();

    return axios.get(imageUrl, {
        headers,
        responseType: 'blob'
      })
      .then((response) => {
        if(response.data) {
            //result type blob
            return response.data
        } else {
            return null;
        }
      })
      .catch((error) => {
        console.log('Error get archivo content: ',error);
      });

}

export default { 
    listArchivos, 
    sendArchivo,
    getArchivo
};
